/*
 * PurrEase Calm Plan buy box.
 * Rendered by sections/purrease-calm-plan.liquid, which prints its data into #cp-config.
 *
 * Two modes share one layout:
 *   plan — the Calm Plan subscription (variant + Appstle selling plan), the default
 *   once — buy the same diffusers and refill vials outright. 2+ rooms get the one-time bundle
 *          discount (CFG.onceBundleOff, cents off each diffuser); Shopify applies the matching
 *          automatic discounts ("2-Room Bundle", "3-Room Bundle") at checkout
 *
 * Nothing here is hardcoded: prices, variant ids, selling plan ids, routes and images all
 * come from the config JSON, so a price change in Shopify or Appstle updates the page.
 */
(function () {
  'use strict';

  var configEl = document.getElementById('cp-config');
  if (!configEl) return;

  var CFG;
  try {
    CFG = JSON.parse(configEl.textContent);
  } catch (error) {
    if (window.console) console.error('[purrease-calm-plan] Invalid #cp-config JSON', error);
    return;
  }

  var PLANS = CFG.plans || {};
  var DIFF = CFG.diffuser;
  var VIAL = CFG.vial;
  var SHIP = CFG.ship;
  var MIN = CFG.min;
  var FREE_ROOMS = CFG.freeRooms;
  var DEFAULT_ROOMS = CFG.defaultRooms;
  var ONCE_D_ID = CFG.onceDiffuserId;
  var ONCE_V_ID = CFG.onceVialId;
  var ONCE_D = CFG.onceDiffuser;
  var ONCE_V = CFG.onceVial;
  var BUNDLE_OFF = CFG.onceBundleOff || {};
  var FREE_MIN = CFG.freeMin;
  var ONCE_OK = !!CFG.onceReady;
  var ROUTES = CFG.routes || {};
  var LINKS = CFG.links || {};
  var BOX_IMAGES = CFG.boxImages || {};
  var ADD_URL = ROUTES.cartAdd || '/cart/add.js';
  var CLEAR_URL = ROUTES.cartClear || '/cart/clear.js';
  var CART_URL = ROUTES.cart || '/cart';
  var CHECKOUT_URL = ROUTES.checkout || '/checkout';
  var TERMS_URL = LINKS.terms || '/pages/calm-plan-terms';
  var REFUND_URL = LINKS.refund || '/pages/refund-policy';
  var CRAFT_SECONDS = CFG.craftSeconds || 7;
  var NAME_PROP = CFG.catNameProperty || "Cat's name";

  /* ---------- helpers ---------- */

  function $(id) {
    return document.getElementById(id);
  }

  function setText(id, text) {
    var el = $(id);
    if (el) el.textContent = text;
  }

  function setHTML(id, html) {
    var el = $(id);
    if (el) el.innerHTML = html;
  }

  function plural(n, word, pluralWord) {
    return n + ' ' + (n > 1 ? pluralWord || word + 's' : word);
  }

  var formatter = null;
  try {
    formatter = new Intl.NumberFormat(CFG.locale || 'en-US', {
      style: 'currency',
      currency: CFG.currency || 'USD',
    });
  } catch (error) {
    formatter = null;
  }

  function money(cents) {
    var value = cents / 100;
    return formatter ? formatter.format(value) : '$' + value.toFixed(2);
  }

  function moneyShort(cents) {
    return cents % 100 === 0 && formatter
      ? formatter.format(cents / 100).replace(/\.00$/, '')
      : money(cents);
  }

  function planForRooms(rooms) {
    for (var key in PLANS) {
      if (Object.prototype.hasOwnProperty.call(PLANS, key) && PLANS[key].rooms === rooms) return PLANS[key];
    }
    return null;
  }

  function roomsLabel(rooms) {
    return rooms === 1 ? '1 Room' : rooms === 2 ? '2 Rooms' : 'Whole Home';
  }

  // Shopper's cat name for the crafting screen and the order line: printable, single-spaced, short.
  function cleanName(value) {
    return String(value || '')
      .replace(/[\u0000-\u001f\u007f<>{}\[\]]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, 24);
  }

  /* ---------- elements ---------- */

  var form = $('cp-form');
  var root = $('cp-top');
  if (!form || !root) return;

  var variantInput = $('cp-vid');
  var planInput = $('cp-plan');
  var cta = $('cp-cta');
  var warn = $('cp-warn');
  var warnDefault = warn ? warn.textContent : '';
  var boxWrap = $('cp-boxwrap-el');
  var boxEl = $('cp-box');
  var boxItems = $('cp-box-items');
  var boxSub = $('cp-box-sub');
  var slotDesktop = $('cp-box-slot-desktop');
  var slotMobile = $('cp-box-slot-mobile');
  var catInput = $('cp-cat');
  var h1El = $('cp-h1');
  var subEl = $('cp-sub');
  // The plan-mode headline lives in the markup; once mode swaps it, so keep the original.
  var H1_PLAN = h1El ? h1El.innerHTML : '';
  var SUB_PLAN = subEl ? subEl.innerHTML : '';
  var MODE = 'plan';
  // Start button = label + a gift line shown on phones. A busy state can replace the markup,
  // so the label is looked up fresh and the original markup rebuilt if it's gone.
  var CTA_HTML = cta ? cta.innerHTML : '';

  function setCtaLabel(text) {
    if (!cta) return;
    var label = $('cp-cta-t');
    if (!label && CTA_HTML.indexOf('cp-cta-t') !== -1) {
      cta.innerHTML = CTA_HTML;
      label = $('cp-cta-t');
    }
    if (label) label.textContent = text;
    else cta.textContent = text;
  }

  /* ---------- "Inside your first box" graphic ---------- */

  var desktopQuery = window.matchMedia('(min-width: 880px)');

  function placeBox() {
    if (!boxWrap) return;
    var target = desktopQuery.matches ? slotDesktop : slotMobile;
    if (target && boxWrap.parentNode !== target) target.appendChild(boxWrap);
    boxWrap.style.display = '';
  }

  placeBox();
  if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', placeBox);
  else if (desktopQuery.addListener) desktopQuery.addListener(placeBox);

  function boxPicture(className, src, delay, rotation) {
    if (!src) return '';
    return (
      '<img class="' + className + '" src="' + src + '" alt="" loading="lazy" width="120" height="120"' +
      ' style="--r:' + rotation + 'deg;animation-delay:' + delay + 'ms">'
    );
  }

  function renderBox(rooms, once) {
    if (!boxItems) return;
    var delay = 0;
    var diffusers = '';
    var vials = '';
    var i;
    for (i = 0; i < rooms; i++) {
      diffusers += boxPicture('cp-pd', BOX_IMAGES.diffuser, delay, i % 2 ? 4 : -4);
      delay += 85;
    }
    for (i = 0; i < rooms; i++) {
      vials += boxPicture('cp-pv', BOX_IMAGES.vial, delay, i % 2 ? 7 : -6);
      delay += 55;
    }
    boxItems.innerHTML =
      '<div class="cp-grp"><div class="cp-grp-imgs">' + diffusers + '</div>' +
      '<b class="cp-grp-lbl">' + plural(rooms, 'diffuser') + '</b></div>' +
      '<div class="cp-grp"><div class="cp-grp-imgs">' + vials + '</div>' +
      '<b class="cp-grp-lbl">' + plural(rooms, 'refill vial') + '</b></div>';

    if (boxSub) boxSub.textContent = plural(rooms, 'diffuser') + ' + ' + plural(rooms, 'refill') + ' · 30 days of calm';

    var title = root.querySelector('.cp-boxtitle');
    if (title) title.textContent = once ? '📦 In your order' : '📦 Inside your first box';
    setText('cp-box-next', once ? 'Refills sold separately' : 'Next refill lands on day 30');

    var seal = root.querySelector('.cp-box-seal');
    if (seal) seal.style.display = once ? 'none' : '';

    if (boxEl) {
      boxEl.classList.remove('cp-bounce');
      void boxEl.offsetWidth; // restart the CSS animation
      boxEl.classList.add('cp-bounce');
    }
  }

  /* ---------- price maths ---------- */

  // One-time bundle discount: cents off each diffuser once the order covers enough rooms. It mirrors
  // the automatic discounts in Shopify (the best tier wins, they never stack), so the page and the
  // checkout show the same total. 1 room is always the regular price.
  function bundleOffEach(rooms) {
    var best = 0;
    for (var key in BUNDLE_OFF) {
      if (!Object.prototype.hasOwnProperty.call(BUNDLE_OFF, key)) continue;
      var off = Number(BUNDLE_OFF[key]) || 0;
      if (rooms >= parseInt(key, 10) && off > best) best = off;
    }
    return Math.min(best, ONCE_D);
  }

  function onceSave(rooms) {
    return rooms * bundleOffEach(rooms);
  }

  function onceRegular(rooms) {
    return rooms * (ONCE_D + ONCE_V);
  }

  function onceTotal(rooms) {
    return onceRegular(rooms) - onceSave(rooms);
  }

  // Free shipping is judged on the total after the bundle discount, like Shopify's rate does.
  function onceShipping(rooms) {
    return onceTotal(rooms) >= FREE_MIN ? 0 : SHIP;
  }

  // A refill reorder is vials only, at the regular vial price.
  function refillShipping(rooms) {
    return rooms * ONCE_V >= FREE_MIN ? 0 : SHIP;
  }

  function planShipping(rooms) {
    return rooms >= FREE_ROOMS ? 0 : SHIP;
  }

  function selectedRooms() {
    var picked = form.querySelector('input[name="cprooms"]:checked');
    return picked ? parseInt(picked.dataset.rooms, 10) || 1 : DEFAULT_ROOMS;
  }

  // Plan cards show the real monthly price plus the real price of the diffusers the plan
  // includes. The diffuser gift is revealed after the crafting screen, never here.
  function updateRoomCards(once) {
    form.querySelectorAll('.cp-room').forEach(function (label) {
      var input = label.querySelector('input');
      if (!input) return;
      var rooms = parseInt(input.dataset.rooms, 10) || 1;
      var plan = PLANS[input.value] || planForRooms(rooms);
      var price = label.querySelector('.cp-room-mo');
      var per = label.querySelector('.cp-room-per');
      var free = label.querySelector('.cp-room-free');
      var ship = label.querySelector('.cp-room-ship');
      if (price) price.textContent = once ? money(onceTotal(rooms)) : plan ? money(plan.recurring) : '';
      if (per) per.textContent = once ? '' : '/mo';
      var save = once ? onceSave(rooms) : 0;
      if (free) free.textContent = once ? (save ? 'Save ' + moneyShort(save) : 'One-time') : '+ ' + money(rooms * DIFF) + (rooms > 1 ? ' diffusers' : ' diffuser');
      if (!ship) return;
      if (once) {
        var onceShip = onceShipping(rooms);
        ship.textContent = onceShip ? '+ ' + money(onceShip) + ' shipping' : '🚚 Free shipping';
        ship.className = onceShip ? 'cp-room-ship cp-room-ship-fee' : 'cp-room-ship';
      } else if (rooms >= FREE_ROOMS) {
        // "priority" drops out on narrow phones (CSS) so the strip stays on one line
        ship.innerHTML = '🚚 Free <span class="cp-pri">priority </span>shipping';
        ship.className = 'cp-room-ship';
      } else {
        ship.textContent = '+ ' + money(SHIP) + ' shipping';
        ship.className = 'cp-room-ship cp-room-ship-fee';
      }
    });
  }

  function updateOnceGrid() {
    for (var n = 1; n <= 3; n++) {
      var total = onceTotal(n);
      var save = onceSave(n);
      var ship = onceShipping(n);
      setHTML('cp-oc-price-' + n, (save ? '<s class="cp-oc-was">' + money(onceRegular(n)) + '</s>' : '') + money(total));
      setText(
        'cp-oc-unit-' + n,
        (save
          ? plural(n, 'diffuser') + ' + ' + plural(n, 'refill') + ' · bundle saves ' + moneyShort(save)
          : plural(n, 'diffuser') + ' at ' + money(ONCE_D) + ' + ' + plural(n, 'refill') + ' at ' + money(ONCE_V)) +
          (ship ? ' · + ' + money(ship) + ' shipping' : ' · free shipping')
      );
      var plan = planForRooms(n);
      setText('cp-oc-delta-' + n, plan ? 'Calm Plan members pay less for this — and get a welcome gift.' : '');
    }

    var rooms = selectedRooms();
    var selectedPlan = planForRooms(rooms);
    if (selectedPlan) {
      // First order at the one-time (bundle) price, then a vials-only reorder every month after.
      var onceThreeMonths = onceTotal(rooms) + onceShipping(rooms) + (MIN - 1) * (rooms * ONCE_V + refillShipping(rooms));
      var planThreeMonths = selectedPlan.intro + selectedPlan.recurring * (MIN - 1) + planShipping(rooms) * MIN;
      var pctLess = Math.floor((1 - planThreeMonths / onceThreeMonths) * 100);
      setText(
        'cp-once-foot-txt',
        'Over the same first ' + MIN + ' months for ' + plural(rooms, 'room') + ', buying outright costs ' + money(onceThreeMonths) + '.' +
          (pctLess > 0 ? ' Calm Plan members pay ' + pctLess + '% less — and their first box comes with a welcome gift.' : '')
      );
    }
  }

  function showWarning(message) {
    if (!warn) return;
    warn.textContent = message || warnDefault;
    warn.classList.add('cp-show');
  }

  function hideWarning() {
    if (!warn) return;
    warn.textContent = warnDefault;
    warn.classList.remove('cp-show');
  }

  /* ---------- render ---------- */

  function update() {
    var picked = form.querySelector('input[name="cprooms"]:checked');
    if (!picked) return;
    var variantId = picked.value;
    var plan = PLANS[variantId];
    if (!plan) return;

    var rooms = plan.rooms || parseInt(picked.dataset.rooms, 10) || 1;
    var once = MODE === 'once';
    root.classList.toggle('cp-once', once);

    var planButton = $('cp-mode-plan');
    var onceButton = $('cp-mode-once');
    if (planButton) planButton.setAttribute('aria-pressed', once ? 'false' : 'true');
    if (onceButton) onceButton.setAttribute('aria-pressed', once ? 'true' : 'false');

    var intro = plan.intro;
    var recurring = plan.recurring;
    var canStartPlan = !!plan.plan && plan.available;
    var shipForPlan = planShipping(rooms);
    var totalOnce = onceTotal(rooms);
    var saveOnce = onceSave(rooms);
    var shipOnce = onceShipping(rooms);
    var payOnce = totalOnce + shipOnce;

    setText('cp-mode-plan-sub', '🎁 Welcome gift');
    setText('cp-mode-once-sub', shipOnce ? '+ ' + money(shipOnce) + ' shipping' : 'Free shipping');
    updateRoomCards(once);

    if (once) {
      variantInput.value = ONCE_D_ID;
      planInput.value = '';
      setHTML(
        'cp-h1',
        'Own ' + (rooms === 2 ? 'both outright' : rooms > 2 ? 'all ' + rooms + ' outright' : 'it outright') +
          ' for <span>' + money(totalOnce) + '.</span> <em>No plan, no minimum.</em>'
      );
      setText(
        'cp-sub',
        saveOnce
          ? 'Nothing renews: ' + rooms + ' PurrEase diffusers and ' + rooms + ' × 48 ml refills, with ' + moneyShort(saveOnce) + ' off for doing ' +
              rooms + ' rooms at once. When a vial runs dry in 30 days you reorder it yourself.'
          : rooms > 1
            ? 'Regular price, nothing renews: ' + rooms + ' PurrEase diffusers at ' + money(ONCE_D) + ' each, plus ' + rooms + ' × 48 ml refills at ' +
              money(ONCE_V) + ' each. When a vial runs dry in 30 days you reorder it yourself.'
            : 'Regular price, nothing renews: a PurrEase diffuser at ' + money(ONCE_D) + ', plus a 48 ml refill at ' + money(ONCE_V) +
              '. When it runs dry in 30 days you reorder it yourself.'
      );
      setText('cp-media-tag', 'Buy once');
      setHTML('cp-media-badge', 'Your order<span>' + plural(rooms, 'diffuser') + ' + ' + rooms + ' 30-day refill' + (rooms > 1 ? 's' : '') + ' · ships within 48h</span>');
      setText('cp-plan-chip', 'One-time purchase');
      setText('cp-step2-lbl', 'What you pay');
      setText('cp-today-k', 'You pay');
      setText('cp-intro-per', '');
      setText('cp-intro', money(totalOnce));
      setText('cp-today-was', saveOnce ? money(onceRegular(rooms)) : '');
      setText(
        'cp-today-n',
        plural(rooms, 'diffuser') + ' + ' + plural(rooms, 'refill') + (saveOnce ? ' at the ' + rooms + '-room bundle price' : '') +
          (shipOnce ? ', plus ' + money(shipOnce) + ' shipping' : ', shipped free')
      );
      setText('cp-recurring-k', 'Then, when it runs dry');
      setText('cp-recurring', money(ONCE_V));
      setText('cp-recurring-small', ' / vial');
      setText('cp-recurring-n', 'You reorder refills yourself — one per room, roughly every 30 days. No reminder, no auto-ship.');
      setText('cp-st-diff-l', saveOnce ? rooms + ' diffusers · bundle price' : (rooms > 1 ? rooms + ' diffusers' : 'Diffuser') + ' at ' + money(ONCE_D));
      setText('cp-st-diff-w', saveOnce ? money(rooms * ONCE_D) : '');
      setHTML('cp-st-diff-p', money(rooms * ONCE_D - saveOnce));
      setText('cp-st-vial-l', (rooms > 1 ? rooms + ' refill vials' : 'First 30-day refill') + ' at ' + money(ONCE_V));
      setText('cp-st-vial-w', '');
      setText('cp-st-vial-p', money(rooms * ONCE_V));
      var shipWasOnce = $('cp-st-ship-w');
      var shipPriceOnce = $('cp-st-ship-p');
      if (shipWasOnce) shipWasOnce.style.display = 'none';
      if (shipPriceOnce) {
        shipPriceOnce.textContent = shipOnce ? money(shipOnce) : 'FREE';
        shipPriceOnce.className = shipOnce ? 'cp-fee' : 'cp-free';
      }
      setText('cp-st-total', money(payOnce));
      setText('cp-st-save', saveOnce ? 'You save ' + moneyShort(saveOnce) : '');
      setText('cp-under-ship', shipOnce ? money(shipOnce) + ' priority shipping' : 'Free priority shipping (orders ' + moneyShort(FREE_MIN) + '+)');
      setText('cp-under-2', 'Ships within 48h, tracked');
      setText('cp-under-3', '30-day returns on unopened items');
      if (cta) {
        setCtaLabel('Add to Cart — ' + money(totalOnce) + ' →');
        cta.disabled = !ONCE_OK;
      }
      setText('cp-sticky-btn', 'Add to Cart →');
      if (ONCE_OK) hideWarning();
      else showWarning();
      setHTML(
        'cp-nudge-txt',
        'Calm Plan members pay <b>far less than ' + money(payOnce) + '</b> for this same box, refills arrive on their own — and every new plan comes with a <b>welcome gift</b>.'
      );
      setHTML(
        'cp-legal',
        money(totalOnce) + ' today for ' + rooms + ' PurrEase diffuser' + (rooms > 1 ? 's' : '') + ' and ' + rooms + ' × 48 ml refill vial' + (rooms > 1 ? 's' : '') +
          (saveOnce
            ? ': ' + money(onceRegular(rooms)) + ' at regular price, less the ' + money(saveOnce) + ' ' + rooms + '-room bundle discount, applied automatically at checkout.'
            : ' at their regular price.') +
          ' One-time purchase — no subscription, no minimum, nothing auto-renews. ' +
          (shipOnce ? money(shipOnce) + ' priority shipping.' : 'Free priority shipping on orders ' + moneyShort(FREE_MIN) + '+.') +
          ' Unopened items can be returned within 30 days of delivery for a refund of the product price; return shipping is paid by you and opened refill vials cannot be returned. <a href="' +
          REFUND_URL + '">Refund Policy</a>.'
      );
      setText('cp-sticky-now', money(totalOnce));
      setText('cp-sticky-sub', 'one-time · no plan');
    } else {
      variantInput.value = variantId;
      planInput.value = plan.plan || '';
      var freeShipping = rooms >= FREE_ROOMS;
      var diffusersTotal = rooms * DIFF;
      // Landing state: real monthly price + real diffuser price. The first-box price and the
      // diffuser gift are shown on the reveal screen (assets/purrease-calm-reveal.js), before checkout.
      if (h1El && h1El.innerHTML !== H1_PLAN) h1El.innerHTML = H1_PLAN;
      if (subEl && subEl.innerHTML !== SUB_PLAN) subEl.innerHTML = SUB_PLAN;
      setText('cp-media-tag', '🎁 Welcome gift inside');
      setHTML('cp-media-badge', 'Your first box<span>' + plural(rooms, 'diffuser') + ' + first 30-day refill' + (rooms > 1 ? 's' : '') + ' · ships within 48h</span>');
      setText('cp-step2-lbl', 'Your Calm Plan');
      setText('cp-plan-chip', 'Calm Plan · ' + roomsLabel(rooms));
      setText('cp-today-k', 'Refills · monthly');
      setText('cp-intro', money(recurring));
      setText('cp-today-was', '');
      setText('cp-today-n', (rooms > 1 ? rooms + ' fresh vials' : 'A fresh vial') + ' every month, before the last runs dry · ' + (freeShipping ? 'free priority shipping' : '+ ' + money(SHIP) + ' shipping'));
      setText('cp-intro-per', '/ mo');
      setText('cp-recurring-k', rooms > 1 ? 'Diffusers' : 'Diffuser');
      setText('cp-recurring', money(diffusersTotal));
      setText('cp-recurring-small', '');
      setText('cp-recurring-n', (rooms > 1 ? rooms + ' × ' + money(DIFF) : money(DIFF)) + ', one time · one per room, yours to keep');
      setText('cp-gift-tease-txt', 'New members receive a welcome gift with their first box. It’s revealed the moment your plan is crafted.');
      setText('cp-under-ship', 'Exact price shown before checkout');
      setText('cp-under-2', freeShipping ? 'Free priority shipping' : 'Ships within 48h, tracked');
      setText('cp-under-3', 'Cancel online after ' + MIN + ' boxes');
      if (cta) {
        setCtaLabel('Start My Calm Plan →');
        cta.disabled = !canStartPlan;
      }
      setText('cp-sticky-btn', 'Start My Calm Plan →');
      if (canStartPlan) hideWarning();
      else showWarning();
      setHTML(
        'cp-legal',
        'The Calm Plan is a monthly subscription. After your first box, refills renew automatically every month at ' + money(recurring) +
          (freeShipping ? '' : ' + ' + money(SHIP) + ' shipping') + ' until you cancel. ' + MIN + '-box minimum (your first box + ' + (MIN - 1) +
          ' monthly refills), then skip, pause or cancel anytime from your account. You’ll see your first-box price and welcome gift on the next screen, before checkout. <a href="' +
          TERMS_URL + '">Calm Plan Terms</a>.'
      );
      setText('cp-sticky-now', money(recurring) + '/mo');
      setText('cp-sticky-sub', roomsLabel(rooms) + ' · 🎁 welcome gift');
      setText('cp-tl-today', 'Welcome price, revealed in your plan');
      setText('cp-tl-monthly', money(recurring) + ' a month');
      setText('cp-vs-member', money(recurring / rooms));
      setText('cp-vs-ship', freeShipping ? 'FREE' : money(SHIP));
      setText('cp-vs-foot', 'Members pay less for every refill, never run out mid-month, and get a welcome gift with their first box.');
      root.querySelectorAll('.cp-member-price').forEach(function (el) {
        el.textContent = money(recurring / rooms);
      });
    }

    updateOnceGrid();
    renderBox(rooms, once);
  }

  function setMode(mode, scroll) {
    if (mode === 'once' && !ONCE_OK) return;
    MODE = mode;
    update();
    if (scroll) {
      var buyBox = $('cp-buy');
      if (buyBox) buyBox.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  /* ---------- cart ---------- */

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
    });
  }

  // Cart adds are sent form-encoded (items[0][id]=…&items[0][selling_plan]=…), the same format a
  // native product form uses. Shopify rejected the 2 Rooms Calm Plan with "Variant can only be
  // purchased with a selling plan" whenever the identical request was sent as JSON (Oct 2026),
  // while the form-encoded request works for every plan and for one-time items.
  // Nested objects (line item properties) become items[0][properties][Name]=value.
  function postItems(url, items) {
    var body = new URLSearchParams();
    items.forEach(function (item, index) {
      Object.keys(item).forEach(function (key) {
        var value = item[key];
        if (value && typeof value === 'object') {
          Object.keys(value).forEach(function (sub) {
            body.append('items[' + index + '][' + key + '][' + sub + ']', String(value[sub]));
          });
        } else {
          body.append('items[' + index + '][' + key + ']', String(value));
        }
      });
    });
    return fetch(url, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: body,
    });
  }

  // Replaces the cart with exactly these items, then sends the shopper straight to checkout.
  // Resolves with nothing on success; rejects with { message } when Shopify refuses the items.
  function replaceCartAndCheckout(items) {
    return postJSON(CLEAR_URL)
      .catch(function () {
        /* an uncleared cart is not fatal */
      })
      .then(function () {
        return postItems(ADD_URL, items);
      })
      .then(function (response) {
        if (response.ok) {
          window.location.href = CHECKOUT_URL;
          return;
        }
        return response
          .json()
          .catch(function () {
            return {};
          })
          .then(function (data) {
            throw { message: data.description || data.message || '' };
          });
      });
  }

  // Saves and restores the button's markup (the Start button carries a label + gift line).
  function setBusy(button, busyText) {
    if (!button) return function () {};
    var original = button.innerHTML;
    button.textContent = busyText;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    return function restore() {
      button.innerHTML = original;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    };
  }

  function addOnce(rooms, button) {
    if (!ONCE_OK) return;
    var restore = setBusy(button, 'Adding…');
    replaceCartAndCheckout([
      { id: ONCE_D_ID, quantity: rooms },
      { id: ONCE_V_ID, quantity: rooms },
    ]).catch(function (error) {
      restore();
      if (error && error.message) showWarning(error.message);
      else window.location.href = CART_URL;
    });
  }

  // Builds the subscription line. The optional cat name rides along as a visible line item
  // property, so it shows on the checkout line and the order ("Cat's name: Luna").
  function planLine(variantId, sellingPlan, catName) {
    var line = { id: variantId, quantity: 1, selling_plan: sellingPlan };
    if (catName) {
      line.properties = {};
      line.properties[NAME_PROP] = catName;
    }
    return line;
  }

  // Runs the existing cart -> checkout flow for the plan the shopper confirmed on the reveal.
  // Resolves when the browser is heading to checkout; rejects with { message } when Shopify refuses.
  function claimPlan(selection, button) {
    var restore = setBusy(button, 'Reserving your box…');
    return replaceCartAndCheckout([planLine(selection.variantId, selection.sellingPlan, selection.catName)]).catch(function (error) {
      restore();
      if (error && error.message) throw error;
      // Network failure: fall back to a normal form post, which also lands on checkout.
      form.removeEventListener('submit', onSubmit);
      form.submit();
    });
  }

  function onSubmit(event) {
    event.preventDefault();
    if (cta && cta.disabled) return;
    if (MODE === 'once') {
      addOnce(selectedRooms(), cta);
      return;
    }
    var variantId = parseInt(variantInput.value, 10);
    var sellingPlan = planInput.value;
    var plan = PLANS[variantInput.value];
    if (!variantId || !sellingPlan || !plan) return;

    var rooms = plan.rooms || selectedRooms();
    var selection = {
      variantId: variantId,
      sellingPlan: sellingPlan,
      rooms: rooms,
      intro: plan.intro,
      recurring: plan.recurring,
      diffuser: DIFF,
      ship: planShipping(rooms),
      min: MIN,
      catName: catInput ? cleanName(catInput.value) : '',
      termsUrl: TERMS_URL,
      craftSeconds: CRAFT_SECONDS,
    };

    // Crafting screen + reveal. If that script failed to load, go straight to checkout as before.
    if (window.PECalmReveal && typeof window.PECalmReveal.open === 'function') {
      window.PECalmReveal.open(selection, {
        money: money,
        returnFocus: event.submitter || cta,
        onClaim: function (button) {
          return claimPlan(selection, button);
        },
      });
      return;
    }
    claimPlan(selection, cta).catch(function (error) {
      showWarning(error && error.message);
    });
  }

  /* ---------- wiring ---------- */

  form.querySelectorAll('input[name="cprooms"]').forEach(function (input) {
    input.addEventListener('change', update);
  });

  var modePlanButton = $('cp-mode-plan');
  var modeOnceButton = $('cp-mode-once');
  if (modePlanButton) modePlanButton.addEventListener('click', function () { setMode('plan', false); });
  if (modeOnceButton) modeOnceButton.addEventListener('click', function () { setMode('once', false); });

  var nudgeButton = $('cp-nudge-btn');
  if (nudgeButton) nudgeButton.addEventListener('click', function () { setMode('plan', false); });

  var toPlanButton = $('cp-once-toplan');
  if (toPlanButton) toPlanButton.addEventListener('click', function () { setMode('plan', true); });

  root.querySelectorAll('[data-once-rooms]').forEach(function (button) {
    button.addEventListener('click', function () {
      var rooms = parseInt(button.dataset.onceRooms, 10) || 1;
      var pick = form.querySelector('input[name="cprooms"][data-rooms="' + rooms + '"]');
      if (pick && !pick.disabled) pick.checked = true;
      setMode('once', false);
      addOnce(rooms, button);
    });
  });

  root.querySelectorAll('[data-cp-mode]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      setMode(link.dataset.cpMode, true);
    });
  });

  // Deep links from ads and emails: ?rooms=1|2|3 and ?buy=once (or #cp-once).
  try {
    var params = new URLSearchParams(window.location.search);
    var roomsParam = parseInt(params.get('rooms'), 10);
    if (roomsParam >= 1 && roomsParam <= 3) {
      var roomsInput = form.querySelector('input[name="cprooms"][data-rooms="' + roomsParam + '"]');
      if (roomsInput && !roomsInput.disabled) roomsInput.checked = true;
    }
    if (params.get('buy') === 'once' && ONCE_OK) MODE = 'once';
  } catch (error) {
    /* URLSearchParams unsupported: keep defaults */
  }
  if (window.location.hash === '#cp-once' && ONCE_OK) MODE = 'once';

  update();
  form.addEventListener('submit', onSubmit);

  if (catInput) {
    var syncName = function () {
      var clean = cleanName(catInput.value);
      if (clean) catInput.setAttribute('name', 'properties[' + NAME_PROP + ']');
      else catInput.removeAttribute('name');
    };
    catInput.addEventListener('input', syncName);
    catInput.addEventListener('blur', function () {
      var clean = cleanName(catInput.value);
      if (clean !== catInput.value) catInput.value = clean;
      syncName();
    });
    syncName();
  }

  // Back from checkout via the browser's back button restores this page from cache with the
  // buttons still in their busy state; put them back.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    update();
    root.querySelectorAll('[aria-busy="true"]').forEach(function (button) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    });
    root.querySelectorAll('.cp-oc-btn').forEach(function (button) {
      if (ONCE_OK) button.textContent = 'Add to cart';
    });
  });

  /* ---------- gallery ---------- */

  var heroImage = $('cp-hero-img');
  var thumbs = root.querySelectorAll('.cp-thumb');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (other) {
        other.classList.remove('cp-on');
        other.removeAttribute('aria-current');
      });
      thumb.classList.add('cp-on');
      thumb.setAttribute('aria-current', 'true');
      if (!heroImage || !thumb.dataset.src) return;
      if (thumb.dataset.srcset) heroImage.srcset = thumb.dataset.srcset;
      heroImage.src = thumb.dataset.src;
      if (thumb.dataset.alt) heroImage.alt = thumb.dataset.alt;
    });
  });

  /* ---------- sticky mobile CTA ---------- */

  // Phones (the bar is hidden from 880px up): the bar shows whenever the real Start button isn't
  // fully on screen, above or below, so the button is always one tap away. It stays down while
  // the shopper types her name, so it never rides up on top of the keyboard.
  var sticky = $('cp-sticky');
  if (sticky && cta && 'IntersectionObserver' in window) {
    var ctaInView = true;
    var typingName = false;
    var syncSticky = function () {
      var show = !ctaInView && !typingName;
      sticky.classList.toggle('cp-on', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) sticky.removeAttribute('inert');
      else sticky.setAttribute('inert', '');
    };
    new IntersectionObserver(
      function (entries) {
        var entry = entries[entries.length - 1];
        ctaInView = entry.isIntersecting && entry.intersectionRatio >= 0.95;
        syncSticky();
      },
      { threshold: [0, 0.95, 1] }
    ).observe(cta);
    if (catInput) {
      catInput.addEventListener('focus', function () { typingName = true; syncSticky(); });
      catInput.addEventListener('blur', function () { typingName = false; syncSticky(); });
    }
  }

  // Phones show "For" in front of the name field, so the placeholder reads "For her name (optional)".
  if (catInput && catInput.getAttribute('data-placeholder-mobile')) {
    var desktopPlaceholder = catInput.getAttribute('placeholder') || '';
    var mobilePlaceholder = catInput.getAttribute('data-placeholder-mobile');
    var syncPlaceholder = function () {
      catInput.setAttribute('placeholder', desktopQuery.matches ? desktopPlaceholder : mobilePlaceholder);
    };
    syncPlaceholder();
    if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', syncPlaceholder);
    else if (desktopQuery.addListener) desktopQuery.addListener(syncPlaceholder);
  }

  /* ---------- fade-in sections ---------- */

  var fades = root.querySelectorAll('.cp-fade');
  if (!('IntersectionObserver' in window)) {
    fades.forEach(function (el) { el.classList.add('cp-in'); });
  } else {
    var fadeObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('cp-in');
          fadeObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.12 }
    );
    fades.forEach(function (el) { fadeObserver.observe(el); });
  }
})();